import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import '../styles/DetalleNoticia.css';

const DetalleNoticia = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [noticia, setNoticia] = useState(null);

    useEffect(() => {
        const fetchNoticia = async () => {
            const { data } = await supabase.from('noticias').select('*').eq('id', id).single();
            if (data) setNoticia(data);
        };
        fetchNoticia();
    }, [id]);

    if (!noticia) return <div className="loading">Cargando...</div>;

    return (
        <div className="detalle-noticia-page">
            <div className="detalle-card">
                <button className="btn-volver-atras" onClick={() => navigate(-1)}>
                    ← Volver a Noticias
                </button>

                <header className="detalle-header">
                    <span className="detalle-fecha">📅 {new Date(noticia.fecha).toLocaleDateString()}</span>
                    <h1>{noticia.titulo}</h1>
                </header>

                <div className="detalle-hero-img">
                    <img src={noticia.imagen_url} alt={noticia.titulo} />
                </div>

                <div className="detalle-cuerpo">
                    {noticia.cuerpo}
                </div>

                <footer className="detalle-footer">
                    <p>Comuna de Santo Domingo - Gestión Institucional</p>
                    <p>Información oficial para los vecinos.</p>
                </footer>
            </div>
        </div>
    );
};

export default DetalleNoticia;